<template>
  <AdblockTopbar />
  <div class="px-4 sm:px-6 lg:px-16 max-w-screen-xl lg:mx-auto">
    <HeaderApp />

    <div class="text__view flex flex-col justify-center text-center mb-5">
      <h1 class="font-semibold text-2xl my-5">Top Brands</h1>
      <p class="leading-6 max-w-5xl mx-auto">
        Learn how the top brands use their social media, websites and much more
        to be on top of the game. These 3000 eCommerce brands are ordered by
        their Alexa rank.
      </p>
    </div>
    <Filters
      :active_filters="{
        country: true,
        industry: true,
      }"
      :placeholder="'Search a brand by keywords'"
      :origin="'topbrands'"
      class="hidden xl:grid grid-cols-8 grid-flow-col justify-center items-center"
    />

    <div v-if="['free'].includes(roleUser)">
      <UpgradePlans :text="' the top 3000 eCommerce/Shopify brands'" />
      <div
        v-if="brands && brands.length"
        class="library__list py-4 lg:py-10 items-start"
      >
        <Brand
          v-for="brand in brands"
          :key="brand.id"
          :data="brand"
          class="library__item"
          :isCollection="false"
        />
      </div>
    </div>
    <div
      v-else-if="brands && brands.length"
      class="library__list py-4 lg:py-10 items-start"
    >
      <Brand
        v-for="brand in brands"
        :key="brand.id"
        :data="brand"
        class="library__item"
        :isCollection="false"
      />
    </div>

    <div
      class="grid mt-24 p-8 text-center justify-center items-center content-center my-auto"
      v-else
    >
      <div>
        <h2 class="text-4xl font-semibold mb-4">
          Looking for Top brands 👀
        </h2>
        <p class="mb-10 text-lg">
          We recommend to clean the filters
        </p>
        <div class="flex justify-center">
          <Button
            @click="getInitialBrands()"
            class="px-12 bg-indigo-600 hover:bg-indigo-500 text-white"
            >Clean filters</Button
          >
        </div>
      </div>
    </div>

    <Pagination
      :totalElements="totalTopBrands"
      :pageView="pageNumber"
      nameView="TopBrands"
    />
  </div>
</template>

<script>
import { computed, onBeforeMount } from "vue";
import { useStore } from "vuex";
import HeaderApp from "@/components/Header";
import { useRouter } from "vue-router";
import AdblockTopbar from "@/components/AdblockTopbar";
import Brand from "@/components/Brand/index";
import Pagination from "@/components/Pagination";
import Button from "@/components/UI/Button";
import UpgradePlans from "@/components/UpgradePlans";
import Filters from "@/components/Filters";
export default {
  components: {
    HeaderApp,
    Brand,
    AdblockTopbar,
    Button,
    UpgradePlans,
    Pagination,
    Filters,
  },
  setup() {
    const store = useStore();
    const router = useRouter();
    onBeforeMount(async () => {
      const status = computed(() => store.state.status);
      if (!status.value) {
            console.log("1")

        router.push("/pricing");
      }
    });

    const brands = computed(() => store.state.topBrands);
    const roleUser = computed(() => store.state.role);
    const pageNumber = computed(() => store.state.pageTopBrands);
    const totalTopBrands = computed(() => store.state.totalTopBrands);

    const getInitialBrands = () => {
      store.commit("CLEAN_FILTERS_TOP_BRANDS");
    };
    return {
      brands,
      roleUser,
      totalTopBrands,
      pageNumber,
      getInitialBrands,
    };
  },
};
</script>

<style scoped>
.library__list {
  @apply grid gap-y-10 gap-x-10;
  justify-content: space-between;
  grid-template-columns: repeat(auto-fit, minmax(19rem, 22rem));
}
.library__item {
  max-width: 24rem;
  min-width: 18rem;
  width: 100%;
}
</style>
